
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/training",
      function () {
        return require("private-next-pages/services/training.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/training"])
      });
    }
  